import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import classnames from 'classnames';

import {Badge} from '../../badge/badge';
import type {Props as BadgeProps} from '../../badge/badge';

import styles from './icon-button.module.css';

type ButtonBadgeProps = BadgeProps & {
    shouldShow: boolean;
};

type Props = {
    // TODO: Make this work, maybe needs newer than flow 0.53?
    // ...HTMLButtonElement,
    icon: React.ComponentType<any>;
    text?: string | number;
    onClick: (e: React.SyntheticEvent<any>) => void;
    getButtonRef?: any;
    variant?: 'primary' | 'danger' | 'ai';
    noHoverBackground?: boolean;
    tooltipText?: string;
    isSmall?: boolean;
    isDisabled?: boolean;
    size?: null | string | number;
    noPadding?: boolean;
    alignCenter?: boolean;
    forceHover?: boolean;
    useBlueIcon?: boolean;
    color?: string;
    badgeProps?: ButtonBadgeProps;
};

export const IconButton = (props: Props) => {
    React.useEffect(() => {
        ReactTooltip.rebuild();

        return () => ReactTooltip.hide();
    });

    const {
        icon: Icon,
        variant,
        noHoverBackground,
        getButtonRef,
        tooltipText,
        isSmall,
        isDisabled,
        size = 16,
        noPadding,
        alignCenter,
        useBlueIcon,
        forceHover,
        color,
        badgeProps,
        ...htmlButtonProps
    } = props;

    const buttonStyles = classnames(styles['icon-button'], variant && styles[variant], {
        [styles['icon-button--small']]: isSmall,
        [styles['icon-button--blue']]: useBlueIcon,
        [styles['no-hover-bg']]: noHoverBackground,
        [styles.disabled]: isDisabled,
        [styles['no-padding']]: noPadding,
        [styles['force-hover']]: forceHover,
    });

    const buttonElement = (
        <button
            type='button'
            // @ts-expect-error
            onClick={props.onClick}
            ref={getButtonRef}
            data-tip={tooltipText}
            {...htmlButtonProps}
            // @ts-expect-error
            className={classnames(buttonStyles, htmlButtonProps?.className)}
        >
            <Icon
                wrapWithDiv={false}
                size={size}
                alignCenter={alignCenter}
                color={color}
                fill={color}
            />
            {props.text ? <span className={styles['button-text']}>{props.text}</span> : undefined}
        </button>
    );

    if (badgeProps && badgeProps.shouldShow) {
        return (
            <div className='pos-relative'>
                {buttonElement}
                <Badge
                    color={badgeProps.color}
                    shouldFlash={badgeProps.shouldFlash}
                    contents={badgeProps.contents}
                />
            </div>
        );
    }

    return buttonElement;
};
